import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  useForm,
} from "@pankod/refine-antd";
import { IBranchOffices } from "interfaces";
import { BranchOfficesForm } from "components/forms";

export const BranchOfficesEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IBranchOffices>();
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <BranchOfficesForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Edit>
  );
};
